import React, { useState } from "react";
import {
  Modal,
  ModalBody,
} from "reactstrap";
import "./index.css";

function ImageModal(props) {
  const { toggle, imageModal, setImageModal,image } = props;
  console.log("ImageModalImageModal",image);
  const closeBtn = (
    <button
      className="close"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        backgroundColor: "#FFF",
        borderColor: "#2E7C7B",
        display: "flex",
        justifyContent: "space-evenly",
      }}
      onClick={toggle}
      type="button"
    >
      <div className="x">X</div>
    </button>
  );

  const handleCloseImage = () => {
    setImageModal(!imageModal);
  };

  return (
    <div>
      <Modal
        isOpen={imageModal}
        onHide={handleCloseImage}
        className="all-transaction-main-modal"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
        scrollable={true}
      >
        <ModalBody
          className="transactionModalBody"
          style={{ marginTop: "25px" }}
        >
        <div>
          <img src={image}
            width="100%" 
          />
        </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ImageModal;
